import React, { useMemo } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEntityContext } from '../EntityContext';
export const EntityColumnNamePicker = props => {
    const { value, disabled, entityId, entityTable, options: optionsProp, textFieldProps, onChange } = props;
    const { entities } = useEntityContext();
    const schema = useMemo(() => {
        return entities === null || entities === void 0 ? void 0 : entities.find(schema => {
            return schema.id && entityId
                ? schema.id === entityId
                : entityTable && schema.tableName === entityTable;
        });
    }, [entities, entityId, entityTable]);
    const options = useMemo(() => {
        return (optionsProp ||
            ((schema === null || schema === void 0 ? void 0 : schema.columns) || []).map(column => {
                const { columnName, displayName } = column;
                return { columnName, displayName };
            }));
    }, [optionsProp, schema]);
    const selected = useMemo(() => {
        return value
            ? options.find(option => option.columnName === value)
            : undefined;
    }, [options, value]);
    return (React.createElement(Autocomplete, { className: 'field', options: options, disabled: disabled, value: selected || null, getOptionLabel: option => option.displayName, onChange: (_, value) => onChange === null || onChange === void 0 ? void 0 : onChange(value === null || value === void 0 ? void 0 : value.columnName), renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Select Entity Column' }, textFieldProps, { InputProps: Object.assign(Object.assign({}, params.InputProps), textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps), InputLabelProps: Object.assign(Object.assign({}, params.InputLabelProps), textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputLabelProps) }))) }));
};
export default EntityColumnNamePicker;
//# sourceMappingURL=EntityColumnNamePicker.js.map